import React from "react";

import "./toolbar.css";

import { Button } from "@material-ui/core";

import noSignalImg from "../../../images/no_signal.png";

import mailImg from "../../../images/mail.png";

import DrawerToggleButton from "../SideDrawer/drawerToggleButton";

import * as getInfo from "../../Utils/info";

const toolbar = (props) => {
  let language = localStorage.getItem("language");

  if (props.messages_badge === "" || props.messages_badge === undefined)
    props.messages_badge = 0;

  let titulo = "";
  switch (props.label) {
    case "home":
      if (language === "en") {
        titulo = "Home";
      } else {
        titulo = "Inicio";
      }
      break;
    case "today":
      if (language === "en") {
        titulo = "Today's Trips";
      } else {
        titulo = "Viajes de Hoy";
      }
      break;
    case "yesterday":
      if (language === "en") {
        titulo = "Yesterday's Trips";
      } else {
        titulo = "Viajes de Ayer";
      }
      break;
    case "tomorrow":
      if (language === "en") {
        titulo = "Tomorrow's Trips";
      } else {
        titulo = "Viajes de Mañana";
      }
      break;
    case "messages":
      if (language === "en") {
        titulo = "Messenger";
      } else {
        titulo = "Mensajería";
      }
      break;
    case "settlements":
      if (language === "en") {
        titulo = "Trip History";
      } else {
        titulo = "Historial de Viajes";
      }
      break;
    case "settings":
      if (language === "en") {
        titulo = "Settings";
      } else {
        titulo = "Configuraciones";
      }
      break;
    case "profile":
      if (language === "en") {
        titulo = "Profile";
      } else {
        titulo = "Perfil";
      }
      break;
    case "assistance":
      if (language === "en") {
        titulo = "Assistance";
      } else {
        titulo = "Asistencia";
      }
      break;
    default:
    //nothing...
  }

  let el_size = { fontSize: "1.3rem" };
  if (!props.online && props.messages_badge > 0 && getInfo.Width() <= 320) {
    el_size = { fontSize: "1.1rem" };
  }

  return (
    <header className='toolbar'>
      <nav className='toolbar__navigation'>
        <div className='toolbar__toggle-button'>
          <DrawerToggleButton click={props.drawerClickHandler} />
        </div>
        <div className='toolbar__titulo' style={el_size}>
          {titulo}
        </div>

        {props.messages_badge > 0 ? (
          <div className='toolbar__mail'>
            <img
              src={mailImg}
              alt=''
              style={{ height: 40, position: "relative", top: 5 }}
              onClick={props.messagesClickHandler}
            />
            <div
              className='toolbar__mail_div'
              onClick={props.messagesClickHandler}
            >
              {props.messages_badge}
            </div>
          </div>
        ) : null}

        <div className='toolbar__signal'>
          <Button color='inherit' onClick={() => window.location.reload(false)}>
            <i className='material-icons left' style={{ fontSize: "40px" }}>
              autorenew
            </i>
          </Button>
        </div>
      </nav>
    </header>
  );
};

export default toolbar;
